import React, { useCallback, useState } from 'react';

// Context for ReminderModal state management
interface ReminderModalContextType {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
}

const ReminderModalContext = React.createContext<ReminderModalContextType | undefined>(undefined);

export const useReminderModal = () => {
  const context = React.useContext(ReminderModalContext);
  if (!context) {
    throw new Error('useReminderModal must be used within a ReminderModalProvider');
  }
  return context;
};

export const ReminderModalProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const onOpen = useCallback(() => setIsOpen(true), []);
  const onClose = useCallback(() => setIsOpen(false), []);

  const value = React.useMemo(
    () => ({
      isOpen,
      onOpen,
      onClose,
    }),
    [isOpen, onOpen, onClose],
  );

  return <ReminderModalContext.Provider value={value}>{children}</ReminderModalContext.Provider>;
};
